import { NavigationGuard } from "vue-router"

const addLink = (href: string, id: string, callback?: () => void) => {
    let link = document.createElement("link")
    link.id = id
    link.rel = "stylesheet"
    link.href = href

    if(callback) {
        link.onload = callback;
    }
    
    var mainLinkEl = window.document.getElementsByTagName('title')[0];
    mainLinkEl.insertAdjacentElement("afterend", link)
}

const initCss = (app: 'bigfile' | 'sentstatus', callback?: () => void) => {
    document.getElementById('cubelook-css')?.remove();
    
    const basePath = process.env.NODE_ENV === "production" ? "/cubelook" : ""
    const cssPath = `${basePath}/assets/${app}/css/style.css`
    const version = (new Date()).getTime();

    addLink(`${cssPath}?version=${version}`, 'cubelook-css', callback);
}

const CssGuard: NavigationGuard = async (to, from, next) => {
    let routePath = to.path.toLowerCase();

    if(routePath.startsWith('/bigfile') || routePath.startsWith('/recipient')) {
        initCss('bigfile', () => { next(); });
    } else {
        initCss('sentstatus', () => { next(); });
    }
}

export { CssGuard }